export const formatDate = (dateString?: string) => {
  if (!dateString) return "N/A";
  return new Date(dateString).toLocaleDateString();
};

export const calculateAge = (dateOfBirth?: string) => {
  if (!dateOfBirth) return null;
  try {
    const birthDate = new Date(dateOfBirth);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  } catch {
    return null;
  }
};

export const formatAddress = (address: any) => {
  if (typeof address === "object" && address !== null) {
    return `${address.street || ""} ${address.no || ""}, ${address.city || ""}, ${
      address.district || ""
    }, ${address.province || ""}, ${address.country || ""}`.trim() || "N/A";
  }
  return address || "N/A";
};

export const formatCountry = (patientData: any) => {
  if (patientData?.country) return patientData.country;
  if (typeof patientData?.address === "object" && patientData?.address !== null) {
    return patientData.address.country || "";
  }
  return "";
};

export const isStatusTrue = (status: any): boolean => {
  return status === "true" || status === true;
};

export const hasDisplayValue = (value: unknown): boolean => {
  if (value == null) return false;
  if (typeof value === "string") {
    const trimmed = value.trim();
    return trimmed !== "" && trimmed !== "N/A" && trimmed !== "-";
  }
  if (typeof value === "number") return Number.isFinite(value);
  if (typeof value === "boolean") return value;
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === "object") {
    return Object.values(value as Record<string, unknown>).some(hasDisplayValue);
  }
  return Boolean(value);
};

export const formatAddressIfPresent = (address: unknown): string | null => {
  const formatted = formatAddress(address);
  return hasDisplayValue(formatted) && formatted !== "N/A" ? formatted : null;
};

